import React, { useCallback, useEffect, useState, useMemo } from "react";
import useAsync from "react-use-async-hook";
import qs from "querystring";
import _ from "lodash";
import { Formik, Form } from "formik";
import * as yup from "yup";
import { Redirect, Link, useLocation } from "react-router-dom";
import { FormGroup, Label, Input } from "reactstrap";

import * as AuthAPI from "../../../api/auth";
import { useSetLoading } from "../../utils/hooks/loader";
import addNotification from "../../utils/notification/notification";
import AlertMessage from "../../utils/AlertMessage/AlertMessage";

const VerifyToken = () => {
    let { search } = useLocation();
    const [token, setToken] = useState(null);

    useEffect(() => {
        if (search) {
            const { token } = qs.parse(search.split("?")[1]);
            setToken(token);
        }
    }, [search]);

    const [requestInProgress, setInProgress] = useState(true);
    const [tokenVerified, setTokenVerification] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [redirectToLogin, setRedirect] = useState(false);
    const [isSuccess, setSuccess] = useState(false);

    /**
     * Verify token
     */
    const {
        loading: verifyTokenLoader,
        execute: executeVerifyToken
    } = useAsync({
        autoExecute: false,
        task: AuthAPI.doLinkVerification,
        dataLoader: useCallback(res => {
            setTokenVerification(true);
            setInProgress(false);
        }, []),
        onError: useCallback(error => {
            setTokenVerification(false);
            setInProgress(false);
            setAlertMessage({
                title: "Session Expired",
                message:
                    "It seems like your session is expired. Please! Try Again."
            });
        }, [])
    });

    useEffect(() => {
        if (token) {
            executeVerifyToken({
                token
            });
        }
    }, [token]);

    /**
     * Update Psssword
     */
    const {
        loading: updatePasswordLoader,
        execute: executeUpdatePassword
    } = useAsync({
        autoExecute: false,
        task: useCallback(async (payload, formikBag) => {
            return {
                res: await AuthAPI.createPassword(payload),
                formikBag
            };
        }, []),
        dataLoader: useCallback(({ res, formikBag }) => {
            formikBag.setSubmitting(false);
            addNotification({
                type: "success",
                title: "Success",
                message: _.get(res, "data.message")
            });
            setSuccess(true);
        }, []),
        onError: useCallback(error => {
            addNotification({
                type: "danger",
                title: "Error",
                message: _.get(
                    error,
                    "response.data.message",
                    "Oops! Something went wrong"
                )
            });
        }, [])
    });

    const showLoader = useMemo(
        () => verifyTokenLoader || requestInProgress || updatePasswordLoader,
        [verifyTokenLoader, requestInProgress, updatePasswordLoader]
    );
    useSetLoading(showLoader);

    return (
        <React.Fragment>
            {token ? (
                tokenVerified ? (
                    <div className="password-section">
                        <Formik
                            initialValues={{
                                newPassword: "",
                                confirmPassword: "",
                                token: ""
                            }}
                            validationSchema={yup.object().shape({
                                newPassword: yup
                                    .string()
                                    .min(
                                        6,
                                        "Password must be more than 6 character"
                                    )
                                    .max(
                                        20,
                                        "Password must be less than 20 character"
                                    )
                                    .required("Password is required"),
                                confirmPassword: yup
                                    .string()
                                    .required("Password is required")
                                    .test(
                                        "passwords-match",
                                        "Passwords must match",
                                        function(value) {
                                            return (
                                                this.parent.newPassword ===
                                                value
                                            );
                                        }
                                    )
                            })}
                            onSubmit={(values, formikBag) => {
                                executeUpdatePassword(
                                    {
                                        password: values.newPassword,
                                        token
                                    },
                                    formikBag
                                );
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleSubmit,
                                setSubmitting,
                                setFieldValue,
                                handleBlur,
                                isSubmitting
                            }) => {
                                const handleChange = e => {
                                    const { name, value } = e.target;
                                    setFieldValue(name, value);
                                    setSubmitting(false);
                                };
                                return (
                                    <Form
                                        id="resetpasswordForm"
                                        onSubmit={handleSubmit}
                                    >
                                        <div className="positioned-back text-center text-md-left">
                                            <Link to="/">
                                                <i className="fas fa-arrow-left"></i>
                                            </Link>
                                            <h4>Create New Password</h4>
                                        </div>
                                        <p className="password-description text-center text-md-left">
                                            Please create a new password and
                                            confirm access to our services
                                        </p>
                                        {!isSuccess ? (
                                            <React.Fragment>
                                                <FormGroup>
                                                    <Label
                                                        className="form-label-theme"
                                                        for="newPassword"
                                                    >
                                                        New Password
                                                    </Label>
                                                    <Input
                                                        className="form-input-theme"
                                                        placeholder="Enter your New password"
                                                        type="password"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        name="newPassword"
                                                        value={
                                                            values.newPassword
                                                        }
                                                        id="newPassword"
                                                    />
                                                    {errors.newPassword &&
                                                    touched.newPassword ? (
                                                        <span className="error-input-msg">
                                                            {errors.newPassword}
                                                        </span>
                                                    ) : null}
                                                </FormGroup>
                                                <FormGroup>
                                                    <Label
                                                        className="form-label-theme"
                                                        for="confirmPassword"
                                                    >
                                                        Confirm Password
                                                    </Label>
                                                    <Input
                                                        className="form-input-theme"
                                                        placeholder="Confirm You New Password"
                                                        type="password"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        name="confirmPassword"
                                                        id="confirmPassword"
                                                        value={
                                                            values.confirmPassword
                                                        }
                                                    />
                                                    {errors.confirmPassword &&
                                                    touched.confirmPassword ? (
                                                        <span className="error-input-msg">
                                                            {
                                                                errors.confirmPassword
                                                            }
                                                        </span>
                                                    ) : null}
                                                </FormGroup>
                                                <button
                                                    type="submit"
                                                    disabled={isSubmitting}
                                                    className="text-uppercase btn-theme theme-green"
                                                >
                                                    Create Password
                                                </button>
                                            </React.Fragment>
                                        ) : (
                                            <div className="auth-successalert-wrapper">
                                                <div className="successalert-card">
                                                    <i className="fas fa-check-circle"></i>
                                                    <span>
                                                        New password has been
                                                        set successfuly. Back to
                                                        <Link to="/">
                                                            Login
                                                        </Link>
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                ) : (
                    <AlertMessage
                        toggleAlertModal={() => {
                            setAlertMessage(null);
                            setRedirect(true);
                        }}
                        toggleAlertState={Boolean(alertMessage)}
                        successMsg={_.get(alertMessage, "message")}
                        showCancelButton={false}
                        title={_.get(alertMessage, "title")}
                    />
                )
            ) : (
                <AlertMessage
                    toggleAlertModal={() => {
                        setRedirect(true);
                    }}
                    toggleAlertState={true}
                    successMsg={"Invalid Token"}
                    showCancelButton={false}
                    title={"Invalid Token"}
                />
            )}
            {redirectToLogin && <Redirect to="/" />}
        </React.Fragment>
    );
};

export default VerifyToken;
